// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "6f986f9e5aff10c7bca3cfe971ecac10f90740d7/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};